import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import { bindAll } from '@bibliocommons/utils-react';
import { Dropdown, DropdownMenuItem } from '@bibliocommons/base-dropdown';
import { Button } from '@bibliocommons/base-buttons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { bibFormatChooser } from '@bibliocommons/analytics-event-composers';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';

import BibLink from 'app/components/shared/BibLink';
import BibManifestationInfo from '../BibManifestationInfo';

import './MoreFormatsDropdown.scss';

const { composeFormatPickerSelectionEvent, composeFormatPickerExpandEvent } = bibFormatChooser;

function renderFormatOptions(manifestation) {
  const handleClick = () => {
    sendAnalyticsEvents(composeFormatPickerSelectionEvent(manifestation.getIn(['briefInfo', 'format'])));
  };
  return (
    <DropdownMenuItem
      key={`format-${manifestation.getIn(['briefInfo', 'format']).toLowerCase()}`}
      handleClick={handleClick}
    >
      <BibLink metadataId={manifestation.getIn(['briefInfo', 'metadataId'])}>
        <BibManifestationInfo bib={manifestation} availability={manifestation.get('availability')} showAvailability />
      </BibLink>
    </DropdownMenuItem>
  );
}

export class MoreFormatsDropdown extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  renderMenu() {
    return this.props.manifestations.map(manifestation => renderFormatOptions(manifestation)).toArray();
  }

  renderTrigger(handleToggle, expanded) {
    const handleClick = () => {
      handleToggle();
      sendAnalyticsEvents(composeFormatPickerExpandEvent(!expanded));
    };
    return (
      <Button className="more-formats-button" handleClick={handleClick}>
        <span aria-hidden>+{this.props.manifestations.size}</span>
        <ScreenReaderMessage>
          <FormattedMessage id="format_chooser_sr_more_formats" values={{ count: this.props.manifestations.size }} />
        </ScreenReaderMessage>
      </Button>
    );
  }

  render() {
    return (
      <div className="cp-more-formats-dropdown">
        <Dropdown right className="formats-dropdown" renderTrigger={this.renderTrigger} dataKey="more-formats-dropdown">
          {this.renderMenu()}
        </Dropdown>
      </div>
    );
  }
}

MoreFormatsDropdown.propTypes = {
  manifestations: ImmutablePropTypes.list.isRequired
};

export default MoreFormatsDropdown;
